import { defineTranslations, i18n } from '@introcloud/blocks';
import { BlockOptions, BlockProps } from '@introcloud/page';
import { useNavigation } from '@react-navigation/native';
import React from 'react';
import { Image } from 'react-native';
import { Caption, Card, Paragraph, Title } from 'react-native-paper';
import { RouteNavigation } from '../core/Routes';

defineTranslations({
  en: {
    app: {
      gelegraaf: {
        cta: {
          title: "Intree Magazine: read today's issue here!",
          description:
            'During Intreeweek we publish articles and photos in this digital edition of Intree Magazine, our daily digital magazine.',
          gate: 'You can read the Intree Magazine every day from 09:00 by clicking this card.',
        },
      },
    },
  },

  nl: {
    app: {
      gelegraaf: {
        cta: {
          title: 'Intree Magazine: lees de laatste editie hier!',
          description:
            "Tijdens de Intreeweek publiceren we artikelen en foto's in deze digitale editie van de Intree Magazine, on dagelijks digitale magazine.",
          gate: ' Je kan elke dag vanaf 09:00 de Intree Magazine lezen door hier te klikken.',
        },
      },
    },
  },
});

export function GelegraafBlock(
  block: BlockProps<BlockOptions> & { kind: 'custom' }
) {
  const { navigate } = useNavigation<RouteNavigation<'Info'>>();
  return (
    <Card
      onPress={() => navigate('Gelegraaf')}
      style={{
        alignItems: 'center',
        paddingBottom: 16,
        marginTop: 16,
        marginHorizontal: 16,
      }}
    >
      <Image
        style={{ width: 150, height: 150, alignSelf: 'center', margin: 'auto' }}
        source={require('../../assets/news.png')}
      />
      <Title
        key="description"
        style={{
          textAlign: 'center',
          alignSelf: 'center',
          paddingHorizontal: 16,
          paddingVertical: 0,
          lineHeight: 24,
        }}
      >
        {i18n.t('app.gelegraaf.cta.title')}
      </Title>
      <Paragraph
        key="check-back"
        style={{
          textAlign: 'center',
          alignSelf: 'center',
          marginHorizontal: 16,
          marginTop: 8,
          marginBottom: 0,
        }}
      >
        {i18n.t('app.gelegraaf.cta.description')}{' '}
        <Caption>{i18n.t('app.gelegraaf.cta.gate')}</Caption>
      </Paragraph>
    </Card>
  );
}
